import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import store from '../../store';

import { fetchGet, get24HrPointTime, getBusDetails, getRoute, getDateFormString, fetchPost, get24HoursDateTime } from '../../common/common';
import { updateHeaderText, updateCheckoutDet, updateSeatChartDet, getEditPolicyResults, getOldSeat, getreschedulecharge } from '../../actions/editPolicy-actions';
import { apiUrl } from '../common/constants';
import Modify from '../modify/modify';

class Seatchart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            seatchart: [],
            stchrt: [],
            error: false,
            fares: [],
            selFare: 0,
            selPick: '',
            selDrop: '',
            selSeat: [],
            selSeatFare: [],
            seatFare: 0,
            disSeatFare: 0,
            showPoint: '',
            countLower: 0,
            countUpper: 0,
            showActive: 0,
            showPassDetailsOnward: 0,
            showPassDetailsReturn: 0,
            orderToken: '',
            showDet: {},
            PassDetailsSave: false,
            HasSeater: 0,
            HasSleeper: 0,
            seatcount: 0,
            policy: {}
        }

    }


    componentDidMount() {

        let seatcount = 0;
        if (this.props.editPolicy.data.length === 0) {
            let booking_url = '/api/resource/BookingInfo?PNR=' + this.props.match.params.pnrNo;

            //for app webview pass app agentId in api
            const appAgentId = localStorage.getItem("AgentId");
            if(appAgentId){
                booking_url+='&appAgentId='+appAgentId;
            }

            fetchGet(booking_url).then((data) => {
                if (data.Status) {
                    store.dispatch(getEditPolicyResults(data.BookingInfo));
                    store.dispatch(getOldSeat(JSON.parse(JSON.stringify(data.BookingInfo.APIGetBookingDetailsResult[0].PaxDetail))));
                    seatcount = data.BookingInfo.APIGetBookingDetailsResult[0].TotalBerthCount;
                } else {
                    alert(data.Error);
                }
            }).catch(function (error) {
                store.dispatch(getEditPolicyResults(false));
                console.log(error);
            });
        }else{
            let data = this.props.editPolicy.data.APIGetBookingDetailsResult ? this.props.editPolicy.data.APIGetBookingDetailsResult[0] : '';
            seatcount = data.TotalBerthCount ? data.TotalBerthCount : 0;
        }

        if (this.props.editPolicy.buses.length === 0) {
            getBusDetails(this.props.match.params.fromCityId, this.props.match.params.fromCityName, this.props.match.params.toCityId, this.props.match.params.toCityName, this.props.match.params.depDate, this.props.match.params.mode);
        }
        store.dispatch(updateHeaderText('text', 'seatchart-back-icon', 'text1', this.props.match.params.fromCityName + ' - ' + this.props.match.params.toCityName + ' on ' + get24HoursDateTime(this.props.match.params.depTime), 'text2', ''));

        const that = this;
        let url = '/api/resource/seatArrangement?routeID=' + this.props.match.params.rsid + '&journeyDate=' + this.props.match.params.depDate;

        //for app webview pass app agentId in api
        const appAgentId = localStorage.getItem("AgentId");
        if(appAgentId){
            url+='&appAgentId='+appAgentId;
        }

        fetchGet(url).then(function (data) {
            if (data.APIGetChartMicrositeResult.Status) {
                const busDetails = that.props.editPolicy.buses.filter(function (a) { return that.props.match.params.rsid === a.RouteScheduleId })[0];
                const stchrt = [];
                data.APIGetChartMicrositeResult.Seats.forEach(el => {
                    let baseFare = el.Fare;
                    baseFare -= (el.HasSTax ? parseInt(el.ServiceTax, 10) : 0);
                    baseFare -= (el.HasSCharge ? parseInt(el.ServiceCharge, 10) : 0);

                    const opDisFare = busDetails.HasDiscountPolicy ? (busDetails.DiscountAmt > 0 ? busDetails.DiscountAmt : Math.round(baseFare * busDetails.DiscountPer / 100)) : 0;
                    busDetails.HasSeater ? that.setState({ HasSeater: 1 }) : that.setState({ HasSeater: 0 });
                    busDetails.HasSleeper ? that.setState({ HasSleeper: 1 }) : that.setState({ HasSleeper: 0 });
                    baseFare -= (baseFare > 0 ? parseInt(opDisFare, 10) : 0);
                    el.baseFare = baseFare;
                    stchrt.push(el);
                })

                that.setState({ stchrt, seatchart: data.APIGetChartMicrositeResult, seatcount });
                that.parseSeats();
            } else {
                that.setState({ error: data.APIGetChartMicrositeResult.ErrorMessage, seatcount })
            }
            // store.dispatch(getSearchResults(data));
        }).catch(function (error) {
            console.log(error);
        });

        window.addEventListener('click', (e) => {
            if (this.refs.tooltip) {
                if (!(e.target.className === 'list-pick' || e.target.parentNode.className === 'list-pick' || e.target.parentNode.parentNode.className === 'list-pick')) {
                    this.setState({ showDet: {} })
                }
            }
        })

        this.getpolicy();
    }

    showLegend = () => {
        return (
            <div className='legend' style={{
                'padding': '15px',
                'width': '100%',
                'overflowX': 'scroll',
                'whiteSpace': 'nowrap',
                'height': '50px'
            }}>
                <div>
                    <span style={{ background: '#1fb34b' }}></span>
                    General
                </div>
                <div>
                    <span style={{ background: '#ddd' }}></span>
                    Selected
                </div>
                <div>
                    <span style={{ background: '#0295d2' }}></span>
                    Male
                </div>
                <div>
                    <span style={{ background: '#ec1287' }}></span>
                    Female
                </div>
                {
                    this.state.HasSeater === 1 ? <div><span className='st-legend'></span>Seater</div> : ""
                }
                {
                    this.state.HasSleeper === 1 ? <div><span className='st-legend sl'></span>Sleeper</div> : ""
                }
            </div>
        )
    }

    getpolicy = () => {
        let apiurl = '/api/resource/Microsite_ModificationDetailsV1?PNR=' + this.props.match.params.pnrNo;

        //for app webview pass app agentId in api
        const appAgentId = localStorage.getItem("AgentId");
        if(appAgentId){
            apiurl+='&appAgentId='+appAgentId;
        }

        fetchGet(apiurl).then((dt) => {
            let policy = JSON.parse(dt).APIMicrosite_ModificationDetailsV1Result;
            store.dispatch(getreschedulecharge(policy));
        }).catch(function (error) {
            console.log(error);
        });
    }

    showPriceBar = () => {
        const loop = this.state.fares;
        return (
            <div style={{ display: "inline-flex", paddingBottom: "15px", fontSize: "14px", maxWidth: "78vw", overflow: "auto" }}>
                <div onClick={() => this.setState({ selFare: 0 })} style={this.state.selFare === 0 ? { borderBottom: '2px solid', borderColor: window.color['searchBoxBgColor'], color: '#000', padding: '5px 10px', cursor: 'pointer', display: 'inline-block' } : { padding: '5px 10px', cursor: 'pointer', display: 'inline-block' }}>All</div>
                {
                    loop.length > 1 ?
                        loop.map(el => <div key={el} style={this.state.selFare === el ? { borderBottom: '2px solid', borderColor: window.color['searchBoxBgColor'], color: '#000', padding: '5px 10px', cursor: 'pointer', display: 'inline-block' } : { padding: '5px 10px', cursor: 'pointer', display: 'inline-block' }} onClick={() => this.setState({ selFare: el })}>&#8377;{el}</div>)
                        : ''
                }
            </div>
        )
    }

    parseMPolicy = (policy) => {
        var res = { policyAvailble: false, data: [] }
        var data = [];
        if (policy.ModificationPolicy && policy.ModificationPolicy.length > 0) {
            res.policyAvailble = true;
            let pData = policy.ModificationPolicy;
            for (let index = 0; index < pData.length; index++) {
                let dt = pData[index];
                if (index === pData.length - 1) {
                    data.push({ ...dt, label: "Before " + (pData[index].Min / 60).toFixed(1) + " hrs" });
                } else if (index === 0) {
                    data.push({ ...dt, label: "0 to " + (pData[index + 1].Min / 60).toFixed(1) + " hrs" });
                } else {
                    data.push({ ...dt, label: (pData[index].Min / 60).toFixed(1) + " to " + (pData[index + 1].Min / 60).toFixed(1) + " hrs" });
                }
            }
            res.data = data;
        };
        return res;
    }

    showPolicy = (rsid) => {
        if (this.state.showDet[rsid] === 1) {
            const loop = this.props.editPolicy.stChrtOthrDtls[rsid] ? this.props.editPolicy.stChrtOthrDtls[rsid].cnclDetails : false;
            let policy = this.props.editPolicy.reschedulecharge;
            const mPolicy = this.parseMPolicy(policy)
            if (loop) {
                return (
                    <div style={{
                        background: 'rgba(0,0,0,0.2)',
                        width: '100%',
                        height: '100%',
                        position: 'fixed',
                        top: '0',
                        zIndex: '5',
                        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.2)',
                        left: '0'
                    }}>
                        <div
                            ref='tooltip'
                            className='list-pick'
                            style={{
                                maxHeight: '70vh',
                                boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)',
                                lineHeight: '2',
                                zIndex: '5',
                                right: '15px',
                                left: '15px',
                                padding: '15px',
                                background: '#FFF',
                                position: 'fixed',
                                borderRadius: '5px',
                                top: '28vh',
                                overflow: 'scroll',
                            }}>

                            <div className="list-show-wrapper">
                                <div className="list-title">Cancellation Policy</div>
                                <div className="cp-wrapper">
                                    <div className="cp-list">
                                        <div>Time before Departure</div>
                                        <div>Charges</div>
                                    </div>

                                    {

                                        Object.keys(loop).map(el => {
                                            return (
                                                <div className="cp-list" key={el}>
                                                    <div>Within {loop[el]}</div>
                                                    <div>{el}</div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                                {mPolicy.policyAvailble && <div>
                                    <div className="list-title">Modification policy</div>
                                    <div className="md-policy-details">
                                        <div>
                                            <div className="m-head">Prepone charges</div>
                                            <div className="m-title">
                                                <div>Modification Time</div><div>Modification Charges</div>
                                            </div>
                                            {mPolicy.data.map((item, index) =>
                                                <div className="m-policy" key={index}>
                                                    <div>{item.label}</div><div>{item.PreponePer ? item.PreponePer + "%" : "₹" + item.PreponeAmount}</div>
                                                </div>
                                            )}
                                        </div>
                                        <div>
                                            <div className="m-head">Postpone charges</div>
                                            <div className="m-title">
                                                <div>Modification Time</div><div>Modification Charges</div>
                                            </div>
                                            {mPolicy.data.map((item, index) =>
                                                <div className="m-policy" key={index}>
                                                    <div>{item.label}</div><div>{item.PostponePer ? item.PostponePer + "%" : "₹" + item.PostponeAmount}</div>
                                                </div>
                                            )}
                                        </div>
                                        <div>
                                            <div className="m-head">Same day charges</div>
                                            <div className="m-title">
                                                <div>Modification Time</div><div>Modification Charges</div>
                                            </div>
                                            {mPolicy.data.map((item, index) =>
                                                <div className="m-policy" key={index}>
                                                    <div>{item.label}</div><div>{item.SameDayPer ? item.SameDayPer + "%" : "₹" + item.SameDayAmount}</div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                )
            } else {
                return (
                    <div
                        ref='tooltip'
                        className='list-pick'
                        style={{
                            top: '-20px'
                        }}
                    >
                        Loading...
                    </div>
                )
            }
        }
    }

    openOtherDet = (e, rsid, param) => {
        // store.dispatch(updateSeatChartDet(rsid, []));
        e.stopPropagation();
        let showDet = {};
        showDet[rsid] = param;
        this.setState({ showDet });
        if (!this.props.editPolicy.stChrtOthrDtls[rsid]) {
            // const that = this;
            let url = '/api/resource/getRouteInfo?routeID=' + rsid;

            //for app webview pass app agentId in api
            const appAgentId = localStorage.getItem("AgentId");
            if(appAgentId){
                url+='&appAgentId='+appAgentId;
            }
            // fetch(url).then(function(response){
            //     return response.json();
            // }).then(function(data) {
            //     store.dispatch(updateSeatChartDet(rsid, data));
            //     that.setState({ showDet });
            // }).catch(function(error) {
            //     console.log('There has been a problem with your fetch operation: ' + error.message);
            // });
            fetchGet(url)
                .then(data => {
                    store.dispatch(updateSeatChartDet(rsid, data));
                })
                .catch((err) => console.log(err));
        } else {
            if (this.state.showDet[rsid] === param) {
                this.setState({ showDet: {} })
            } else this.setState({ showDet });
        }
    }

    getWidthForDiv = (el) => {
        for (let i = 0; i < el.length; i++) {
            if (el[i].Width === 1) {
                return '60px';
            } else {
                return '100px';
            }
        }
        return '60px';
    }

    getHeightForDiv = (el) => {
        let tempHt = 0;
        for (let i = 0; i < el.length; i++) {
            tempHt += (el[i].Height * 45);
        }
        return (tempHt + 'px');
    }

    showLowerSt = () => {
        const loop = this.state.stchrt.lower;
        return (
            <div style={{
                background: 'rgb(255, 255, 255)',
                boxShadow: 'rgba(0, 0, 0, 0.298039) 0px 0px 2px',
                borderRadius: '3px'
            }}>
                <div>
                    <div style={{
                        width: '50%',
                        display: 'inline-block',
                        padding: '15px',
                        boxSizing: 'border-box',
                        textAlign: 'center'
                    }}>
                        Lower ({this.state.countLower} Seats)
                    </div>
                    <div style={{
                        width: '50%',
                        display: 'inline-block',
                        padding: '15px',
                        boxSizing: 'border-box',
                        textAlign: 'center',
                        border: '1px solid #EEEEEE'
                    }} onClick={() => this.setState({ showActive: 1 })} >
                        Upper ({this.state.countUpper} Seats)
                    </div>
                </div>
                <div style={{
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'row',
                    padding: '60px 0 20px',
                    'justifyContent': 'center'
                }}>

                    <span style={{
                        position: 'absolute',
                        left: '20px',
                        right: '20px',
                        top: '46px',
                        border: '1px solid #EEEEEE'
                    }}></span>

                    {Object.keys(loop).map((el, index) => {
                        if (loop[el] && loop[el].length > 0) {
                            return (
                                <div
                                    key={index}
                                    style={{
                                        position: 'relative',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        width: this.getWidthForDiv(loop[el]),
                                        height: this.getHeightForDiv(loop[el])
                                    }}>
                                    {
                                        Object.keys(loop).length === index + 1 &&
                                        <img src='/img/operator.svg' alt='driver' style={{ position: 'absolute', top: '-55px', width: '36px', right: '4px' }} />
                                    }
                                    {
                                        loop[el].map((ell, indexx) => {
                                            const color = ell.Gender === 'M' ? '#0295d2' : (ell.Gender === 'F' ? '#ec1287' : '#1eb24b');
                
                                            return (
                                                <div
                                                    key={indexx}
                                                    style={this.generateSeatStyle(ell)}
                                                    onClick={() => this.selSeat(ell)}
                                                >
                                                    {ell.IsAvailable ? '₹' + ell.baseFare : 'Sold'}
                                                    {ell.IsAvailable ? <span style={{
                                                        position: 'absolute',
                                                        left: ell.Height === 1 ? '6px' : '0',
                                                        bottom: ell.Height === 1 ? '0' : 'initial',
                                                        //top: ell.Height === 1 ? '3px' : '0',
                                                        //left: ell.Height === 1 ? 'initial' : '3px',
                                                        height: ell.Height === 1 ? '3px' : 'initial',
                                                        width: ell.Height === 1 ? '28px' : 'initial',
                                                        background: color
                                                    }}></span> : ''}
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            )
                        } else {
                            return <div key={index} style={{ width: '40px' }}></div>
                        }
                    })}
                </div>
            </div>
        )
    }

    showUpperSt = () => {
        const loop = this.state.stchrt.upper;
        return (
            <div style={{
                background: 'rgb(255, 255, 255)',
                boxShadow: 'rgba(0, 0, 0, 0.298039) 0px 0px 2px',
                borderRadius: '3px'
            }}>
                <div style={{
                    width: '50%',
                    display: 'inline-block',
                    padding: '15px',
                    boxSizing: 'border-box',
                    textAlign: 'center',
                    border: '1px solid #EEEEEE'
                }} onClick={() => this.setState({ showActive: 0 })} >
                    Lower ({this.state.countLower} Seats)
                </div>
                <div style={{
                    width: '50%',
                    display: 'inline-block',
                    padding: '15px',
                    boxSizing: 'border-box',
                    textAlign: 'center'
                }}>
                    Upper ({this.state.countUpper} Seats)
                </div>

                <div style={{
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'row',
                    padding: '60px 0 20px',
                    'justifyContent': 'center'
                }}>

                    <span style={{
                        position: 'absolute',
                        left: '20px',
                        right: '20px',
                        top: '46px',
                        border: '1px solid #EEEEEE'
                    }}></span>
                    {Object.keys(loop).map((el, index) => {
                        if (loop[el] && loop[el].length > 0) {
                            return (
                                <div
                                    key={index}
                                    style={{
                                        position: 'relative',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        width: this.getWidthForDiv(loop[el]),
                                        height: this.getHeightForDiv(loop[el])
                                    }}
                                >
                                    {
                                        Object.keys(loop).length === index + 1 &&
                                        <img src='/img/operator.svg' alt='driver' style={{ position: 'absolute', top: '-55px', width: '36px', right: '4px' }} />
                                    }
                                    {loop[el].map((ell, indexx) => {
                                        const color = ell.Gender === 'M' ? '#0295d2' : (ell.Gender === 'F' ? '#ec1287' : '#1eb24b');
                                        return (
                                            <div
                                                key={indexx}
                                                style={this.generateSeatStyle(ell)}
                                                onClick={() => this.selSeat(ell)}
                                            >
                                                {ell.IsAvailable ? '₹' + ell.baseFare : 'Sold'}
                                                {ell.IsAvailable ? <span style={{
                                                    position: 'absolute',
                                                    left: ell.Height === 1 ? '6px' : '0',
                                                    bottom: ell.Height === 1 ? '0' : 'initial',
                                                    //top: ell.Height === 1 ? '3px' : '0',
                                                    //left: ell.Height === 1 ? 'initial' : '3px',
                                                    height: ell.Height === 1 ? '3px' : 'initial',
                                                    width: ell.Height === 1 ? '28px' : 'initial',
                                                    background: color
                                                }}></span> : ''}
                                            </div>
                                        )
                                    })}
                                </div>
                            )
                        } else {
                            return <div key={index} style={{ width: '40px' }}></div>
                        }
                    })}
                </div>
            </div>
        )
    }

    parseSeats = () => {
        let lower = {};
        let upper = {};
        let fares = [];
        let countLower = this.state.countLower;
        let countUpper = this.state.countUpper;
        const st = this.state.stchrt;
        st.forEach(el => {
            if (el.baseFare !== 0 && fares.indexOf(el.baseFare) === -1) fares.push(el.baseFare);
            if (el.Deck === 1) {
                if (el.IsAvailable && !el.IsAisle) {
                    countLower++;
                }

                if (Object.keys(lower).indexOf(el.ColumnNo + '') === -1) {
                    lower[el.ColumnNo] = [];
                    if (!el.IsAisle) {
                        lower[el.ColumnNo].push(el);
                    }
                } else {
                    if (!el.IsAisle) {
                        lower[el.ColumnNo].push(el);
                    }
                }
            } else {
                if (el.IsAvailable && !el.IsAisle) {
                    countUpper++;
                }
                if (Object.keys(upper).indexOf(el.ColumnNo + '') === -1) {
                    upper[el.ColumnNo] = [];
                    if (!el.IsAisle) {
                        upper[el.ColumnNo].push(el);
                    }
                } else {
                    if (!el.IsAisle) {
                        upper[el.ColumnNo].push(el);
                    }
                }
            }
        });
        lower = this.parseSt(lower);
        upper = this.parseSt(upper);

        const stchrt = { lower, upper }
        this.setState({ stchrt, fares, countLower, countUpper });
    }

    parseSt = (val) => {
        let keys = Object.keys(val);
        for (let i = 0; i < keys.length; i++) {

            if (keys[i + 1] - keys[i] > 1) {
                val[parseInt(keys[i], 10) + 1] = false;
            }
            if (val[keys[i]] && val[keys[i]].length === 0 && val[keys[i + 1]] && val[keys[i + 1]].length === 0) {
                val[keys[i]] = false;
                delete val[keys[i + 1]];
            }
        }
        return val;
    }

    selSeat = (val) => {

        let selSeat = this.state.selSeat;
        let data = this.props.editPolicy.data.APIGetBookingDetailsResult ? this.props.editPolicy.data.APIGetBookingDetailsResult[0] : '';
        let selSeatFare = this.state.selSeatFare;
        let seatFare = this.state.seatFare;
        let disSeatFare = this.state.disSeatFare;
        const that = this;
        const bus = this.props.editPolicy.buses.filter(function (a) { return that.props.match.params.rsid === a.RouteScheduleId })[0];

        if (val.IsAvailable && (this.state.selFare === 0 || this.state.selFare === val.baseFare)) {
            const index = selSeat.indexOf(val.SeatLabel);

            if (index === -1 && selSeat.length < data.TotalBerthCount) {
                selSeat.push(val.SeatLabel);
                seatFare += val.baseFare;
                if (bus.DiscountAmt > 0 || bus.DiscountPer) {
                    let temp = 0;
                    temp += val.baseFare;
                    temp -= bus.DiscountAmt > 0 ? bus.DiscountAmt : Math.round((temp * bus.DiscountPer / 100));
                    disSeatFare += temp;
                }
            }
            if (index >= 0) {
                selSeat.splice(index, 1);
                seatFare -= val.baseFare;
                if (bus.DiscountAmt > 0 || bus.DiscountPer) {
                    let temp = 0;
                    temp += val.baseFare;
                    temp -= bus.DiscountAmt > 0 ? bus.DiscountAmt : Math.round((temp * bus.DiscountPer / 100));
                    disSeatFare -= temp;
                }
            }
            this.setState({ selSeat, seatFare, disSeatFare, selSeatFare });
        }
    }

    showPickUpPointFn = () => {

        if (!this.props.editPolicy.stChrtOthrDtls[this.props.match.params.rsid]) {
            getRoute(this.props.match.params.rsid);
        }
        const det = this.props.editPolicy.stChrtOthrDtls[this.props.match.params.rsid];
        if (this.state.showPoint === 'pickUp' && det) {
            const loop = det.pickups;
            return (
                <div className="pickupDetails font15-light"
                    style={{ width: '100%', height: 'calc(100% - 60px)', background: '#FFF', position: 'fixed', top: '60px',left:'0px', padding: '0 15px', bottom: '0px', overflowY: 'scroll' }} >
                    {loop.map((el, index) => {
                        return <div className="showPointDetails"
                            style={{ width: '100%', position: 'relative' }}
                            key={index}
                            onClick={
                                () => {
                                    this.setState({ selPick: el, showPoint: 'dropOff' })
                                    store.dispatch(updateHeaderText('text', 'dropOff-back-icon', 'text1', 'Choose dropoff location', 'text2', ''))
                                }
                            } >
                            <div style={{
                                width: '80%',
                                overflow: 'hidden',
                                display: 'inline-block',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                left: '-100%',
                                padding: '18px 5px',
                                textAlign: 'left'
                            }} className="searchPickUpName">
                                {el['PickupName']}
                            </div>
                            <div style={{
                                width: '20%',
                                display: 'inline-block',
                                position: 'absolute',
                                padding: '18px 5px',
                                textAlign: 'right'
                            }} >
                                {get24HrPointTime(el['PickupTime'])}
                            </div>
                        </div>
                    })}
                </div>
            )
        } else {
            return <div className='point-opt'></div>
        }
    }

    showDropOffPointFn = () => {
        const det = this.props.editPolicy.stChrtOthrDtls[this.props.match.params.rsid];
        if (this.state.showPoint === 'dropOff' && det) {
            const loop = det.dropPoints;
            return (
                <div className="dropoffDetails font15-light" style={{ width: '100%', height: 'calc(100% - 60px)', background: '#FFF', position: 'fixed', top: '60px', padding: '0 15px', bottom: '0px', overflowY: 'scroll' }} >
                    {loop.map((el, index) => {
                        return <div className="showPointDetails" style={{ width: '100%', position: 'relative' }} key={index}
                            onClick={() => this.setState({ selDrop: el }, this.saveOrder)}>
                            <div style={{
                                width: '80%',
                                overflow: 'hidden',
                                display: 'inline-block',
                                textOverflow: 'ellipsis',
                                padding: '18px 5px',
                                whiteSpace: 'nowrap',
                                textAlign: 'left'
                            }}>
                                {el['DropoffName']}
                            </div>
                            <div style={{
                                width: '20%',
                                display: 'inline-block',
                                padding: '18px 5px',
                                position: 'absolute',
                                textAlign: 'right'
                            }} >
                                {get24HrPointTime(el['DropoffTime'])}
                            </div>
                        </div>
                    })}
                </div>
            )
        } else {
            return <div className='point-opt'></div>
        }
    }

    seatEnableFn = () => {
        return (
            <div>
                <div style={{ padding: '5px', height: '25px' }}>
                    Selected Seat :
                    <span style={{ float: 'right' }}> {this.state.selSeat.join(', ')} </span>
                </div>
                <div className="font16" style={{
                    textAlign: 'center',
                    color: '#FFF',
                    background: window.color['buttonColor'],
                    padding: '15px',
                    borderRadius: '3px',
                    height: '50px'
                }} onClick={() => {
                    this.setState({ showPoint: 'pickUp' })
                    store.dispatch(updateHeaderText('text', 'pickUp-back-icon', 'text1', 'Choose pickup location', 'text2', ''))
                }} >
                    PROCEED TO BOOK FOR ₹ {this.state.seatFare}
                </div>
            </div>
        )
    }

    seatDisableFn = () => {
        return (
            <div className="font16" style={{
                textAlign: 'center',
                color: '#FFF',
                background: '#EEEEEE',
                padding: '15px',
                borderRadius: '3px',
                height: '50px'
            }}>
                SELECT A SEAT TO PROCEED
            </div>
        )
    }

    saveOrder = () => {
        const srchPrms = this.props.editPolicy.data.APIGetBookingDetailsResult[0];
        let isGenderCheck = 0;
        if (this.state.selSeat.length > 0 && this.state.selPick !== '' && this.state.selDrop !== '') {
            const that = this;
            const bus = this.props.editPolicy.buses.filter(function (a) { return that.props.match.params.rsid === a.RouteScheduleId })[0];
            const pick = this.state.selPick;
            const drop = this.state.selDrop;

            let postData = {
                routeCode: bus.RouteScheduleId,
                BusType: bus.BusType,
                companyId: bus.CompanyId,
                companyName: bus.CompanyName,
                journeyDate: bus.JourneyDate,
                pickUpID: pick.PickupID,
                pickUpName: pick.PickupName,
                pickUpTime: pick.PickupTime,
                pickUpAddress: pick.Address,
                pickUpLandmark: pick.Landmark,
                pickUpPhone: pick.ContactNumbers,
                dropOffID: drop.DropoffID,
                dropOffName: drop.DropoffName,
                dropOffTime: drop.DropoffTime,
                fromCityName: this.props.match.params.fromCityName,
                toCityName: this.props.match.params.toCityName,
                opHasDiscountPolicy: bus.HasDiscountPolicy,
                opDiscountAmt: bus.DiscountAmt,
                opDiscountPer: bus.DiscountPer,
                isNonRefundable: bus.IsNonRefundable,
                amenities: bus.AmenitiesType,
                mode: 'oneway',
                fromCityId: this.props.match.params.fromCityId,
                toCityId: this.props.match.params.toCityId,
                mobile: srchPrms.PassengerContactNo1,
                email: srchPrms.PassengerEmail,
                customerName: srchPrms.PassengerName,
                bookingType: 'reschedule_booking'
            };

            const AgentId = localStorage.getItem("AgentId");
            if(AgentId){
                postData.agent_id = AgentId;
            }

            const AppSource = localStorage.getItem("AppSource");
            if(AppSource){
                postData.source = AppSource;
            }

            const selSeats = this.state.seatchart.Seats;
            let passangerInfo = srchPrms.PaxDetail;
            let index = 0;
            let indx = 0;
            selSeats.forEach(el => {
                if (this.state.selSeat.indexOf(el.SeatLabel) >= 0) {
                    postData['seats[' + index + ']'] = el.SeatLabel;
                    postData['isSleeper[' + index + ']'] = el.Width === 2 || el.Height === 2 ? true : false;
                    postData['isAC[' + index + ']'] = el.IsAC;
                    postData['hasSTax[' + index + ']'] = el.HasSTax;
                    postData['serviceTax[' + index + ']'] = el.ServiceTax;
                    postData['serviceCharge[' + index + ']'] = el.ServiceCharge;
                    postData['hasSCharge[' + index + ']'] = el.HasSCharge;
                    postData['gender[' + index + ']'] = el.Gender;
                    postData['price[' + index + ']'] = el.Fare - (el.HasSCharge ? parseInt(el.ServiceCharge, 10) : 0) - (el.HasSTax ? parseInt(el.ServiceTax, 10) : 0);
                    isGenderCheck = el.HasDoubleSeaterFemaleValidation || el.HasDoubleSlpFemaleValidation || el.HasFemaleValidation ? 1 : isGenderCheck;
                    index++;
                }
            })

            passangerInfo.forEach(ell => {
                postData['name[' + indx + ']'] = ell.PaxName;
                postData['age[' + indx + ']'] = ell.Age;
                indx++;
            })

            if (srchPrms.token) {
                postData['token'] = srchPrms.token
            }
            const url = '/api/expco/ordersave';
            fetchPost(url, postData).then(data => {

                store.dispatch(updateCheckoutDet(data.orderData));

                let ismantispg = false;
                //let logintoken = '';
                
                const apiurl = apiUrl.ismantispg;
                fetchGet(apiurl).then((response) => {
                    ismantispg = response.ismantispg;
                    if (ismantispg) {

                        const genderstring = "?p=" + isGenderCheck;
                        const hostname = window.location.hostname;
                        const coString = '/co/seamless_modification/' + data.orderToken + '/' + this.props.match.params.pnrNo;

                        let windowurl = '';
                        if (hostname.includes("dev.", 0) || hostname.includes("localhost", 0)) {
                            windowurl = "http://dev.checkout.iamgds.com";
                        } else if (window.location.hostname.includes("beta.", 0)) {
                            windowurl = "http://beta.checkout.iamgds.com";
                        } else {
                            windowurl = "https://checkout.iamgds.com";
                        }

                        let url = windowurl + coString + genderstring;

                        window.location.href = url;

                    } else {
                        this.props.history.push('/co/exps/' + data.orderToken + '/' + this.props.match.params.pnrNo + '?p=' + isGenderCheck);
                    }

                }).catch(function (error) {
                    console.log(error);
                });
                
            })
                .catch((err) => console.log(err));
        }
    }

    render() {
        const that = this;
        let data = this.props.editPolicy.data.APIGetBookingDetailsResult ? this.props.editPolicy.data.APIGetBookingDetailsResult[0] : '';
        const busDetails = this.props.editPolicy.buses.filter(function (a) { return that.props.match.params.rsid === a.RouteScheduleId })[0];
        if (this.state.stchrt.lower && data) {
            return (
                <div style={{ position: 'relative', height: '100%', width: '100%' }}>
                    <Modify />
                    <div className='seatchart font14' style={{
                        position: 'relative',
                        width: '100%',
                        height: 'calc(100% - 140px)',
                        top: '60px',
                        overflowY: 'scroll'
                    }}>
                        {this.showLegend()}
                        <div className='seat-wrap' style={{
                            'background': '#EEEEEE',
                            'padding': '15px'
                        }}>
                            {this.showPriceBar()}
                            {
                                busDetails.IsNonRefundable ?
                                    <div className="policy-container"
                                        style={{
                                            color: window.color['searchBoxBgColor'],
                                            position: 'relative',
                                            float: 'right',
                                            top: '5px',
                                            fontSize: '14px'
                                        }} >
                                        Non Refundable
                                    </div> :
                                    <div className="policy-container"
                                        style={{
                                            color: window.color['searchBoxBgColor'],
                                            position: 'relative',
                                            float: 'right',
                                            top: '5px',
                                            fontSize: '14px'
                                        }}
                                        onClick={(event) => this.openOtherDet(event, this.props.match.params.rsid, 1)}
                                    >
                                        Policy
                                    </div>
                            }
                            {this.showPolicy(this.props.match.params.rsid)}
                            <div className='seats'>
                                {this.state.showActive === 0 ? this.showLowerSt() : (this.state.stchrt.upper ? this.showUpperSt() : '')}
                            </div>
                        </div>
                        <div style={{
                            position: 'fixed',
                            padding: '15px',
                            width: '100%',
                            bottom: '0',
                            background: '#FFF',
                            boxShadow: 'rgba(0, 0, 0, 0.298039) 0px 0px 2px'
                        }}>
                            <div style={{ color: window.color.menuBgColor }}>How To Edit?</div>
                            <div>You can select maximum {data.TotalBerthCount} {data.TotalBerthCount > 1 ? 'seats' : 'seat'}</div>
                            {(this.state.seatcount > 0 && this.state.selSeat.length > 0 && this.state.selSeat.length === this.state.seatcount) ? this.seatEnableFn() :  this.seatDisableFn()}
                        </div>
                    </div>
                    {this.state.showPoint === 'pickUp' ? this.showPickUpPointFn() : (this.state.showPoint === 'dropOff' ? this.showDropOffPointFn() : '')}
                </div>
            )
        } else {
            return (
                <div className='loading'>
                    Loading...
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            )
        }
    }

    generateSeatStyle = (ell) => {
        const color = ell.Gender === 'M' ? '#0295d2' : (ell.Gender === 'F' ? '#ec1287' : '#1eb24b');
        return {
            position: 'absolute',
            display: 'flex',
            //flexDirection:'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: (ell.Height * 40) + 'px',
            width: (ell.Width * 40) + 'px',
            margin: '5px',
            paddingRight: !ell.IsAvailable || ell.Height === 2 ? '0' : '5px',
            border: '1px solid',
            borderColor: !ell.IsAvailable ? '#ddd' : color,
            background: !ell.IsAvailable ? '#ddd' : (this.state.selSeat.indexOf(ell.SeatLabel) >= 0 ? color : '#fff'),
            color: !ell.IsAvailable || this.state.selSeat.indexOf(ell.SeatLabel) >= 0 ? '#fff' : '#444',
            opacity: this.state.selFare !== 0 && this.state.selFare !== ell.baseFare ? 0.2 : 1,
            userSelect: 'none',
            cursor: ell.IsAvailable ? 'pointer' : 'not-allowed',
            top: (ell.RowNo * 45) + 'px'
        }
    }
}

const mapStateToProps = function (store) {
    return (store);
};

export default connect(mapStateToProps)(withRouter(Seatchart));


// WEBPACK FOOTER //
// ./src/components/seatchart/seatchart_reschedule.js